import type { InputHTMLAttributes, ReactNode } from 'react';
import { TextInput, cn } from '@forecastify/ui';

/**
 * A labelled text field in the setup flow's dress — the onboarding mockup's: muted at rest with no
 * border, the border and the background arriving on hover and focus (the standing rule for every
 * input in the product, which the mockup happens to agree with here).
 */
export const SETUP_INPUT =
  'bg-muted placeholder:text-muted-foreground hover:border-input focus:border-ring focus:bg-background focus:ring-ring/20 h-9 w-full min-w-0 rounded-md border border-transparent px-3 text-[13px] shadow-none outline-none transition-[border-color,box-shadow,background-color] duration-150 focus:ring-[3px]';

export function SetupField({
  label,
  className,
  ...input
}: InputHTMLAttributes<HTMLInputElement> & { readonly label: string }): ReactNode {
  return (
    <label className="flex min-w-0 flex-col gap-1.5">
      <span className="text-muted-foreground text-[12px] font-medium">{label}</span>
      <TextInput className={cn(SETUP_INPUT, className)} {...input} />
    </label>
  );
}
